<template>
    <modal name="create_group" height="auto" scrollable adaptive>
        <app-card :title="$t('Create group')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-multi-lang-input id="name"
                                          v-model="form.name"
                                          name="name"
                                          rules="required"
                                          :langs="locales && Object.keys(locales)">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-multi-lang-input>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import VehicleGroupService from '@services/vehicleGroup.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                name: {
                    et: '',
                    en:''
                },
            },
            loading: false
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    VehicleGroupService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setGroup', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_group');
        }
    }
};
</script>
